import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Notification } from './notifications';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UUID } from 'angular2-uuid';

@Injectable()
export class NotificationsService {

    private _notificationSource = new BehaviorSubject<any>(null);
    updatedNotification$ = this._notificationSource.asObservable();

    getNotification(): Observable<any> {
        return this._notificationSource.asObservable();
    }

    popUpMsg(payload): any {

        if (payload.id) {
            this._notificationSource.next(payload);
            return payload.id;
        } else {
            const uuid = UUID.UUID();
            Object.assign(payload, {
                id: uuid
            });
            this._notificationSource.next(payload);
            return uuid;
        }
    }

    clear() {
        this._notificationSource.next(null);
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/notifications/notifications.service.ts